import * as numeral from 'numeral';

export default function(value) {
  if (value === '-') {
    return '-';
  }
  let format = '0a';
  if (value > 1000) {
    format = '0.0a';
  }
  return numeral(value)
    .format(format)
    .toUpperCase();
}
